// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"16f1ac61","703":"cf5753f3","787":"a5908871"}[chunkId] + ".chunk.js";
};